import { render, staticRenderFns } from "./BrokerLogoLink.vue?vue&type=template&id=607b6dae&"
import script from "./BrokerLogoLink.vue?vue&type=script&lang=ts&"
export * from "./BrokerLogoLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports